import { Injectable } from '@angular/core';
import { IAuthenticationService, ShellService } from '@mynexus/mfe-core';
import { IUserClaims } from '@mynexus/mynexus-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService implements IAuthenticationService {
  constructor(
    private shellService: ShellService,
  ) {
  }

  getToken(): Promise<string> {
    return this.shellService.authenticationService.getToken();
  }

  get userClaims(): IUserClaims | null {
    return this.shellService.authenticationService.userClaims;
  }

  get userEmail(): string | null {
    return this.shellService.authenticationService.userEmail;
  }

  get userGroups(): string[] {
    return this.shellService.authenticationService.userGroups;
  }

  get userName(): string {
    return this.shellService.authenticationService.userName;
  }

  get userId(): string {
    return this.userClaims.sub;
  }

  get userPermissions(): string[] {
    return this.shellService.authenticationService.userPermissions;
  }
}
